import React, {Component} from 'react';
import {console_log} from "../../utils/helper";

class ActivityIndicator extends Component {
    render() {
        let isLoading = this.props.isLoading;
        return (isLoading) ?
            <div className="activity-indicator">
                <div className="loader">
                    <div className="loader-square"></div>
                </div>
            </div>
            : null;

    }
}

export default ActivityIndicator;


// WEBPACK FOOTER //
// ./src/components/ActivityIndicator/ActivityIndicator.js